import {BaseFlowHandler} from "./BaseFlowHandler.js";
import {iFrameState} from "../../services/IFrameState";
import {Money} from "../../../client/state/misc/Money";
import {isThirdPartyStorageBlocked} from "../../Utils";
import {iFrameConnection} from "../../services/IFrameConnection";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages";
import {CurrencyStore} from "../../../client/state/CurrencyStore.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {Messages} from "../../Messages.js";
import {iFrameAuthService} from "../../services/IFrameAuthService.js";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";


export class PaywallPurchaseFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.payment;

    // TODO @mustfix @branch probably broken
    async start() {
        await iFrameAuthService.promptAuthenticationIfNeeded();

        const {paymentDetails} = iFrameState.iframeParams;

        // TODO @cleanup what is this?
        // Users with third party storage blocked will have a slightly different user experience, meaning that
        // they will be asked to manually make the content payment when they authenticate from the wall iframe.
        if (isThirdPartyStorageBlocked()) {
            iFrameConnection.sendToIFrames(IFrameMessages.MAKE_NEXT_PAYMENT_MANUALLY, {
                offerId: paymentDetails.offerId,
            });
        }

        iFrameConnection.sendToSDK(IFrameMessages.MAKE_PAYMENT_VIA_SDK, {
            request: paymentDetails,
        });
    }

    static getActionButtonLabel() {
        const {paymentDetails} = iFrameState.iframeParams;

        if (!paymentDetails) {
            return "Read article";
        }

        const currency = CurrencyStore.getByIsoCode(paymentDetails.currencyIsoCode || paymentDetails.currencyCode) || iFrameMerchantService.getMerchant().getCurrency();
        const amount = new Money(paymentDetails.amount, currency).toString();

        return Messages.readForAmount(amount);
    }
}
